export const localKeyGenByVedaKeysOfStyleBoxField = 'KeyGenByVedaKeysOfStyleBoxField';
